import momentImport from 'moment-timezone';

const moment: typeof momentImport =
  typeof momentImport === 'function'
    ? momentImport
    : (momentImport as any).default;

export default moment;
